module.exports = __webpack_public_path__ + "img/first-0-opened.1c663381.webp";